(function () {
  var STORAGE_KEY = 'nneeoonn_attribution_v1';
  var QUOTE_PATH = '/pages/get-a-quote';

  /*
   * =========================================================
   * COMMON FUNCTIONS
   * =========================================================
   */

  function normalizePath(path) {
    if (!path) return '/';

    return path.length > 1
      ? path.replace(/\/+$/, '')
      : path;
  }

  function getAttribution() {
    try {
      var stored = localStorage.getItem(STORAGE_KEY);

      if (!stored) {
        return {};
      }

      return JSON.parse(stored) || {};
    } catch (e) {
      return {};
    }
  }

  function saveAttribution(data) {
    try {
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify(data)
      );
    } catch (e) {
      console.warn(
        'NNEEOONN attribution storage error:',
        e
      );
    }
  }

  function isSameSite(url) {
    var currentHost =
      window.location.hostname.replace(/^www\./, '');

    var targetHost =
      url.hostname.replace(/^www\./, '');

    return currentHost === targetHost;
  }

  function setQuoteEntryPage(path) {
    var attribution = getAttribution();

    attribution.quote_entry_page = path || '';

    attribution.quote_entry_timestamp = path
      ? new Date().toISOString()
      : '';

    saveAttribution(attribution);
  }


  /*
   * =========================================================
   * STEP 2
   * FIRST-TOUCH ATTRIBUTION
   * =========================================================
   */

  try {
    var attribution = getAttribution();

    /*
     * Only create First Touch once.
     * Never overwrite an existing first visit.
     */
    if (!attribution.first_visit_timestamp) {
      var params =
        new URLSearchParams(window.location.search);

      attribution.first_landing_page =
        normalizePath(window.location.pathname);

      attribution.first_referrer =
        document.referrer || 'Direct';

      attribution.utm_source =
        params.get('utm_source') || '';

      attribution.utm_medium =
        params.get('utm_medium') || '';

      attribution.utm_campaign =
        params.get('utm_campaign') || '';

      attribution.utm_content =
        params.get('utm_content') || '';

      attribution.utm_term =
        params.get('utm_term') || '';

      attribution.gclid =
        params.get('gclid') || '';

      attribution.fbclid =
        params.get('fbclid') || '';

      attribution.first_visit_timestamp =
        new Date().toISOString();

      saveAttribution(attribution);
    }


    /*
     * =========================================================
     * STEP 3A
     * CAPTURE CLICKS TO THE QUOTE PAGE
     * =========================================================
     */

    document.addEventListener(
      'click',
      function (event) {
        var link =
          event.target.closest('a[href]');

        if (!link) {
          return;
        }

        try {
          var targetUrl = new URL(
            link.href,
            window.location.href
          );

          if (
            isSameSite(targetUrl) &&
            normalizePath(targetUrl.pathname) ===
              QUOTE_PATH &&
            normalizePath(
              window.location.pathname
            ) !== QUOTE_PATH
          ) {
            setQuoteEntryPage(
              normalizePath(
                window.location.pathname
              )
            );
          }
        } catch (e) {
          /*
           * Ignore invalid URLs.
           */
        }
      }
    );


    /*
     * =========================================================
     * STEP 3B
     * QUOTE PAGE FALLBACK
     * =========================================================
     */

    if (
      normalizePath(window.location.pathname) ===
      QUOTE_PATH
    ) {
      if (document.referrer) {
        try {
          var referrerUrl =
            new URL(document.referrer);

          /*
           * Previous page was another
           * NNEEOONN page.
           */
          if (
            isSameSite(referrerUrl) &&
            normalizePath(
              referrerUrl.pathname
            ) !== QUOTE_PATH
          ) {
            setQuoteEntryPage(
              normalizePath(
                referrerUrl.pathname
              )
            );
          }

          /*
           * Visitor entered Quote directly
           * from an external website.
           */
          else if (!isSameSite(referrerUrl)) {
            setQuoteEntryPage('');
          }
        } catch (e) {
          setQuoteEntryPage('');
        }
      }

      /*
       * Direct / bookmark access to Quote.
       */
      else {
        setQuoteEntryPage('');
      }
    }

  } catch (e) {
    console.warn(
      'NNEEOONN attribution tracking error:',
      e
    );
  }


  /*
   * =========================================================
   * STEP 4
   * ACERILL AUTO-FILL + HIDE ATTRIBUTION FIELDS
   * =========================================================
   */

  var ACERILL_FIELDS = {
    first_landing_page:
      '1fbba4aa-553a-435f-8ce0-77aaa9c4ca73',

    first_referrer:
      '27b4fcc2-a539-44e2-abb0-00e41d005250',

    utm_source:
      '981d77a3-22b4-4d94-aadf-8361d7a48238',

    utm_medium:
      '5a773f69-5d08-446f-ac71-c84d128600c4',

    utm_campaign:
      '1981729d-b3fc-4013-9c6b-d59a87f8577b',

    utm_content:
      'a1554762-0610-48c2-a301-2243be05e832',

    utm_term:
      '667348d4-833c-42ad-b4ab-29bb9a48e2ed',

    quote_entry_page:
      '79d97302-486d-4e9e-933b-39a4859f8702',

    submission_page:
      'b7cf6d1f-6bc7-4829-a2e0-39674b17db92',

    gclid:
      'e17eb4fb-aaea-4285-8146-e98eebeaa1ff',

    fbclid:
      '2fcb9c93-a592-4260-9d5e-04f96a96cbd8'
  };


  /*
   * =========================================================
   * WRITE VALUE TO ALL DUPLICATE ACERILL INPUTS
   * =========================================================
   */

  function setAcerillField(
    fieldId,
    value
  ) {
    /*
     * Acerill currently renders duplicate
     * fields with the same name / ID.
     *
     * Therefore update ALL matching fields.
     */
    var inputs =
      document.querySelectorAll(
        '[name="' + fieldId + '"]'
      );

    if (!inputs.length) {
      return false;
    }

    var finalValue =
      value == null
        ? ''
        : String(value);

    inputs.forEach(
      function (input) {

        /*
         * Use native value setter.
         * More reliable for JS-controlled forms.
         */
        try {
          var descriptor =
            Object.getOwnPropertyDescriptor(
              HTMLInputElement.prototype,
              'value'
            );

          if (
            descriptor &&
            descriptor.set
          ) {
            descriptor.set.call(
              input,
              finalValue
            );
          } else {
            input.value =
              finalValue;
          }
        } catch (e) {
          input.value =
            finalValue;
        }


        /*
         * Also update the HTML attribute.
         * Useful for debugging in DevTools.
         */
        input.setAttribute(
          'value',
          finalValue
        );


        /*
         * Notify Acerill that the value changed.
         */
        input.dispatchEvent(
          new Event(
            'input',
            {
              bubbles: true
            }
          )
        );

        input.dispatchEvent(
          new Event(
            'change',
            {
              bubbles: true
            }
          )
        );
      }
    );

    return true;
  }


  /*
   * =========================================================
   * HIDE ALL ATTRIBUTION FIELDS
   * =========================================================
   */

  function hideAcerillFields() {
    Object.keys(
      ACERILL_FIELDS
    ).forEach(
      function (key) {
        var fieldId =
          ACERILL_FIELDS[key];

        var inputs =
          document.querySelectorAll(
            '[name="' + fieldId + '"]'
          );

        inputs.forEach(
          function (input) {
            var wrapper =
              input.closest(
                '.form-field-wrapper'
              );

            if (wrapper) {
              wrapper.style.display =
                'none';
            }
          }
        );
      }
    );
  }


  /*
   * =========================================================
   * BUILD FIELD VALUES
   * =========================================================
   */

  function getAcerillFieldValues() {
    var attribution =
      getAttribution();

    return {
      first_landing_page:
        attribution.first_landing_page ||
        '',

      first_referrer:
        attribution.first_referrer ||
        'Direct',

      utm_source:
        attribution.utm_source ||
        '',

      utm_medium:
        attribution.utm_medium ||
        '',

      utm_campaign:
        attribution.utm_campaign ||
        '',

      utm_content:
        attribution.utm_content ||
        '',

      utm_term:
        attribution.utm_term ||
        '',

      quote_entry_page:
        attribution.quote_entry_page ||
        '',

      submission_page:
        normalizePath(
          window.location.pathname
        ),

      gclid:
        attribution.gclid ||
        '',

      fbclid:
        attribution.fbclid ||
        ''
    };
  }


  /*
   * =========================================================
   * FILL ALL ACERILL ATTRIBUTION FIELDS
   * =========================================================
   */

  function fillAcerillAttributionFields() {

    /*
     * Only run on Quote page.
     */
    if (
      normalizePath(
        window.location.pathname
      ) !== QUOTE_PATH
    ) {
      return false;
    }

    var fieldValues =
      getAcerillFieldValues();

    var allFieldsFound =
      true;

    Object.keys(
      ACERILL_FIELDS
    ).forEach(
      function (key) {

        var fieldId =
          ACERILL_FIELDS[key];

        var success =
          setAcerillField(
            fieldId,
            fieldValues[key]
          );

        if (!success) {
          allFieldsFound =
            false;
        }
      }
    );

    /*
     * Only hide fields after ALL
     * attribution fields exist.
     */
    if (allFieldsFound) {
      hideAcerillFields();
    }

    return allFieldsFound;
  }


  /*
   * =========================================================
   * INITIAL ACERILL LOAD / RE-RENDER HANDLING
   * =========================================================
   */

  function startAcerillSync() {
    var attempts = 0;

    /*
     * 40 attempts × 250ms
     * = approximately 10 seconds.
     */
    var maxAttempts = 40;

    var timer =
      setInterval(
        function () {

          attempts++;

          fillAcerillAttributionFields();

          if (
            attempts >=
            maxAttempts
          ) {
            clearInterval(
              timer
            );
          }

        },
        250
      );
  }


  /*
   * =========================================================
   * MUTATION OBSERVER
   *
   * If Acerill replaces/re-renders fields,
   * refill and hide them again.
   * =========================================================
   */

  function startAcerillObserver() {

    if (!document.body) {
      return;
    }

    var observer =
      new MutationObserver(
        function () {
          fillAcerillAttributionFields();
        }
      );

    observer.observe(
      document.body,
      {
        childList: true,
        subtree: true
      }
    );

    /*
     * Stop observing after initial
     * Acerill rendering period.
     */
    setTimeout(
      function () {
        observer.disconnect();
      },
      15000
    );
  }


  /*
   * =========================================================
   * FINAL SAFETY CHECK BEFORE SUBMISSION
   * =========================================================
   */

  function enablePreSubmitSync() {

    document.addEventListener(
      'click',
      function (event) {

        var button =
          event.target.closest(
            '.submit-button-wrapper .cf-btn'
          );

        if (!button) {
          return;
        }

        if (
          normalizePath(
            window.location.pathname
          ) !== QUOTE_PATH
        ) {
          return;
        }

        /*
         * Force fresh attribution values
         * into every duplicate Acerill field
         * immediately before submission.
         */
        fillAcerillAttributionFields();

      },
      true
    );
  }


  /*
   * =========================================================
   * RUN STEP 4
   * =========================================================
   */

  if (
    normalizePath(
      window.location.pathname
    ) === QUOTE_PATH
  ) {

    startAcerillSync();

    startAcerillObserver();

    enablePreSubmitSync();
  }

})();